<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardAutocompleteRow
        v-model="winningScientificCompetition.commonWork.year"
        :items="yearList"
        item-value="id"
        item-text="year"
        label="Год"
        :no-filter="false"
        placeholder="Выберите год"
        :disabled="isShowMode"
        :required="!isShowMode"
        @input="updateWinningScientificCompetition()"
      />

      <CardAutocompleteRow
        v-model="winningScientificCompetition.reward"
        :items="rewardList"
        item-value="id"
        item-text="name"
        label="Награда"
        placeholder="Выберите тип награды"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.reward"
        @input="
          $v.winningScientificCompetition.reward.$touch()
          updateWinningScientificCompetition()
        "
      />

      <CardFieldRow
        v-model="winningScientificCompetition.founder"
        label="Учредитель / Организатор конкурса"
        placeholder="Добавьте учредителя/организатора конкурса"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.founder"
        @input="
          $v.winningScientificCompetition.founder.$touch()
          updateWinningScientificCompetition()
        "
      />

      <CardFieldRow
        v-model="winningScientificCompetition.commonWork.workName"
        label="Наименование конкурса"
        placeholder="Добавьте наименование конкурса"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.workName"
        @input="
          $v.winningScientificCompetition.commonWork.workName.$touch()
          updateWinningScientificCompetition()
        "
      />

      <CardFieldRow
        v-model="winningScientificCompetition.theme"
        label="Тема НИР"
        placeholder="Добавьте тему НИР"
        :disabled="isShowMode"
        hide-border-bottom
        @input="updateWinningScientificCompetition"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { setValidateMessages } from '../../../scripts/validation'
import CardFieldRow from '../../ui/row/CardFieldRow'
import { mapGetters } from 'vuex'
import { workStatusList, workStatusListName } from '@/scripts/consts'
import CardAutocompleteRow from '@/components/ui/row/CardAutocompleteRow.vue'
import { WinningScientificCompetition } from '@/models/works/WinningScientificCompetition'

export default {
  components: { CardAutocompleteRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    winningScientificCompetition: new WinningScientificCompetition()
  }),

  validations() {
    return {
      winningScientificCompetition: {
        commonWork: {
          workName: { required }
        },
        reward: { required },
        founder: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['yearList', 'rewardList']),
    ...mapGetters('user', ['isAdmin', 'isModerator', 'isModeratorNir']),

    isWorkAccepted() {
      return [workStatusListName.Accepted].includes(
        workStatusList[this.winningScientificCompetition.commonWork.status?.id]
      )
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.winningScientificCompetition.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.winningScientificCompetition[key])
      })

      Object.keys(this.$v.winningScientificCompetition.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.winningScientificCompetition.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateWinningScientificCompetition() {
      this.$emit(
        'update:selected-item',
        new WinningScientificCompetition(this.winningScientificCompetition.getForAPI())
      )
      this.updateInvalid()
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.winningScientificCompetition = new WinningScientificCompetition(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
